import React from 'react';
import { formaterMontant } from './formatMontant';

/**
 * Récapitulatif d'un brouillon de commande : client, adresse, lignes
 * « libellé / montant », frais de livraison et total mis en avant.
 * `commande` : { customerName, customerPhone, deliveryAddress, items[], shippingFee, total }
 */
const RecapitulatifCommande = ({ commande }) => (
  <>
    <div className="mb-3 border-b border-gray-100 pb-3">
      <p className="font-semibold text-gray-900">{commande.customerName}</p>
      <p className="text-gray-600">{commande.customerPhone}</p>
      <p className="text-gray-600">{commande.deliveryAddress}</p>
    </div>
    <ul className="space-y-1.5 tabular-nums">
      {commande.items.map((item) => (
        <li key={item.variant_id} className="flex justify-between gap-4">
          <span className="text-gray-700">{item.item_name} <span className="text-gray-400">× {item.quantity}</span></span>
          <span className="shrink-0 text-gray-900">{formaterMontant(item.price * item.quantity)}</span>
        </li>
      ))}
      <li className="flex justify-between gap-4 text-gray-600">
        <span>Livraison</span>
        <span className="shrink-0">{formaterMontant(commande.shippingFee)}</span>
      </li>
      <li className="flex justify-between gap-4 border-t border-gray-100 pt-2 text-base font-semibold text-gray-900">
        <span>Total</span>
        <span className="shrink-0">{formaterMontant(commande.total)}</span>
      </li>
    </ul>
  </>
);

export default RecapitulatifCommande;
